import React from 'react';
import ReactCalendar from 'react-calendar/dist/entry.nostyle';
import moment from 'moment';
import './calendar.css';

export default function Calendar(props) {
  const altDate = props.altValue ? moment(props.altValue) : null;

  const getTileClass = (obj) => {
    if (altDate) {
      if (moment(obj.date).isSame(altDate, 'day')) {
        return 'react-calendar__tile--altactive';
      }
    }
  };

  return (
    <ReactCalendar
      selectRange={false}
      tileClassName={getTileClass}
      {...props}
    />
  );
}